import api from '../api/axios';

const roleService = {
  /** All predefined action codes (permission catalog) */
  getActions: ()       => api.get('/api/admin/roles/actions'),

  /** All active custom roles */
  getRoles: ()         => api.get('/api/admin/roles'),

  /** Single role detail */
  getRole: (id)        => api.get(`/api/admin/roles/${id}`),

  /** Create a new custom role  { name, description, actionIds: [] } */
  createRole: (data)   => api.post('/api/admin/roles', data),

  /** Update role name/description/actions */
  updateRole: (id, d)  => api.post(`/api/admin/roles/${id}`, d),

  /** Soft-delete a role */
  deleteRole: (id)     => api.delete(`/api/admin/roles/${id}`),

  /** All users with current custom role info */
  getUsers: ()         => api.get('/api/admin/roles/users'),

  /** Assign or unassign a custom role  { userId, customRoleId } (null = unassign) */
  assignRole: (data)   => api.post('/api/admin/roles/assign', data),
};

export default roleService;
